import { EmployeeRecord } from './EmployeeRecord.model';
import { EmployeeSalesTotal } from './EmployeeSalesTotal.model';

export class TimecardRecord {
	pk: string; //venueKey
	sk: string; //TCR_{timeCardId}

	timeinUnix: number;
	checkDate: string;

	id: string;
	jobId: number;
	employeeId: number;
	employee: EmployeeValue;
	job: JobValue;

	timeIn: string;
	timeOut: string;

	regularPayRate: number;
	dailyOvertimePayRate: number;
	weeklyOvertimePayRate: number;

	revenueCenterId: number;

	regularTime: number;
	dailyOvertime: number;
	weeklyOvertime: number;
	totalTime: number;

	cost: number;
	regularPay: number;
	dailyOvertimePay: number;
	weeklyOvertimePay: number;
	overhead: number;

	noSaleCount: number;
	deleteCount: number;

	recordIdHash: string;
	breaks: EmployeeBreak[];
	adjustments: TimecardRecordAdjustment[];
	employeeSalesTotal: EmployeeSalesTotal;

	employeeRecord: EmployeeRecord;

	public constructor(init?: Partial<TimecardRecord>) {
		Object.assign(this, init);
	}
}

class EmployeeValue {
	firstName: string;
	lastName: string;
	nickName: string;

	public constructor(init?: Partial<EmployeeValue>) {
		Object.assign(this, init);
	}
}

class JobValue {
	name: string;
	laborGroup: string;

	public constructor(init?: Partial<JobValue>) {
		Object.assign(this, init);
	}
}

export class EmployeeBreak {
	timecardId: number;
	id: number;
	breakStart: string;
	breakEnd: string;
	duration: number;
	previous: EmployeeBreak;

	public constructor(init?: Partial<EmployeeBreak>) {
		Object.assign(this, init);
	}
}

export class TimecardRecordAdjustment {
	adjustedByEmployeeId: number;
	adjustedValue: string;
	originalValue: string;
	newValue: string;
	adjustmentDateTime: string;

	public constructor(init?: Partial<TimecardRecordAdjustment>) {
		Object.assign(this, init);
	}
}
